import React, { Component } from 'react';

class GridInputCellTemplate extends Component {
    constructor(props) {
        super();

        this.props = props.props;
        this.onBlur = props.onBlur;

        this.state = {
            value: this.props.dataItem[this.props.field]
        };
    }

    handleChange = (e) => {
        let dataItem = this.props.dataItem;
        let value = e.target.value;
        if(value == null){
            value = 0;
        }

        this.setState({value: value});

        this.props.props.onChange({
            dataItem: dataItem,
            field: this.props.field,
            syntheticEvent: e.syntheticEvent,
            value: value
        });
    }

    handleBlur = (e) => {
        let dataItem = this.props.props.dataItem;
        let value = e.target.value;
        if(value == null){
            value = 0;
        }

        this.onBlur({
            dataItem: dataItem,
            value: value
        });
    }

    handleFocus = (event) => {event.target.select();}

    render() {
        return (
            <td onFocus={this.handleFocus}>
                <input                       
                    className="input--table input--inherit-color no-arrows w--60 input--text-align--right"
                    onChange={this.handleChange} 									
                    onBlur={this.handleBlur}
                    value={this.state.value} 
                    type="number"
                    min="0"                      			
				/>
            </td>
        );
    }
}

export default GridInputCellTemplate;
